import React, { Component } from 'react';
import anime from 'animejs';
import update from 'immutability-helper';
import { translate } from 'react-i18next';
import Scroll from 'react-scroll';
// import tapOrClick from 'react-tap-or-click'

import Message from "./message.js";
import SingleSelect from "../components/input/single.js";
import MultiSelect from "../components/input/multi.js";
import TextEntry from "../components/input/text.js";
import Intensity from "../components/input/intensity.js";

// import LineHistogram from "../components/input/line-histogram.js";
import BarChart from "../components/input/bar-chart.js";

class MessageGroup extends Component {

  systemTargets = "#" + this.props.id + " .message-container.system.animate"
  systemBoxes = this.systemTargets + " .message-box"
  userTarget = "#" + this.props.id + " .message-container.user"
  inputTarget = "#" + this.props.id + " .input"
  placeholderTarget = "#" + this.props.id + " .input-placeholder"

  messageAnim
  placeholderAnim

  additional_data = { 
    meta: {
      start_time: performance.now(),
      last_message: performance.now()
    } 
  }

  constructor(props) {
    super(props)

    let animations = { "placeholder": { entering: false }, "message-loading": { entering: true, entered: false}}
    this.props.systemMessages.forEach((msg, i) => {
      animations[msg.id] = { entering: false, entered: this.props.noAnimation }
    })
    this.state = {
      animations: animations,
      inputDisabled: !this.props.noAnimation,
      tapHintFadeAway: 1
    }
    
    this.addMessage = this.addMessage.bind(this)
    this.updateTapHint = this.updateTapHint.bind(this)
    this.animateMessages = this.animateMessages.bind(this)
  }

  addMessage(selected_answer, additional_data = null) {
    // console.log(this.props)
    let timestamp = performance.now()
    if (this.additional_data && this.additional_data.meta && this.additional_data.meta.start_time) {
      this.additional_data["total_time"] = timestamp - this.additional_data.meta.start_time
    }
    // if (additional_data && additional_data.meta.last_interaction) this.additional_data["submission_delay_time"] = timestamp - additional_data.meta.last_interaction
    if (this.props.input) {

      let add_data = Object.assign(this.additional_data, additional_data)
      console.log("ADDITIONAL DATA", add_data)
      this.props.addMessage({
        selected_answer: selected_answer,
        question_id: this.props.input.question_id,
        additional_data: add_data
      })
    }
  }

  componentDidMount() {
    this.placeholderAnim = anime({
      targets: this.placeholderTarget,
      opacity: 1,
      duration: 500,
      delay: 800,
      easing: 'easeInQuad',
      autoplay: false
    })
    this.animateMessages()
    this.scroll()

    document.getElementById('scroll-content').addEventListener('scroll', this.updateTapHint)
  }

  componentWillUnmount() {
    document.getElementById('scroll-content').removeEventListener('scroll', this.updateTapHint)
  }

  updateTapHint(e) {
    if (this.props.input || this.props.noAnimation) return
    const el = e.target
    const bottomScrollHeight = el.scrollHeight - el.offsetHeight
    let percentageFromBottom = 1 - (bottomScrollHeight - el.scrollTop) / (0.35 * window.screen.height)
    if (percentageFromBottom > 0.5) {
      percentageFromBottom = 1.0
    } else {
      percentageFromBottom = 2 * percentageFromBottom
    }
    if (this.state.tapHintFadeAway !== percentageFromBottom) {
      this.setState({
        tapHintFadeAway: percentageFromBottom
      })
    }
  }

  scroll() {
    // console.log("SCROLLING", Scroll.animateScroll)
    Scroll.animateScroll.scrollToBottom({ 
      containerId: 'scroll-content',
      ignoreCancelEvents: false,
      isDynamic: false,
      delay: 0
    })
  }

  animateMessages() {
    if (this.props.noAnimation) {
      return;
    }

    this.messageAnim = anime.timeline();
    const delay = 0

    // let scrollView = document.getElementById("scroll-content")
    // const canScroll = scrollView.clientHeight < scrollView.firstChild.offsetHeight

    // const delay = canScroll ? 300 : 0

    if (this.props.input) {
      this.messageAnim
        .add({
          targets: this.inputTarget,
          opacity: [0, 1],
          duration: 150,
          offset: 150,
          begin: anim => {
            this.setState({ inputDisabled: true })
          },
          complete: anim => {
            this.setState({ inputDisabled: false })
          },
          easing: 'easeInQuart'
        })
    }
    

    this.messageAnim
      .add({
        targets: this.systemTargets, //this.props.hasLoadingBubble ? this.systemTargets : this.systemBoxes,
        opacity: this.props.hasLoadingBubble ? [1, 1] : 1,
        duration: 200,
        offset: delay,
        easing: 'easeInQuart',
        update: anim => {
          const key = 'entered'
          const updates = { entering: {$set: false} }
          let ids = anim.animations.map(animation => animation.animatable.target.id)
          let needsUpdate = ids.some(id => !this.state.animations[id]["entered"])
          if (needsUpdate) {
            // console.log("UPDATING ANIMATIONS", anim)

            let updateParams = ids.reduce(function(acc, cur, i) {
              acc[cur] = updates
              acc[cur][key] = {$set: true}
              return acc;
            }, {});
            this.setState(prevState => ({
              animations: update(
                prevState.animations,
                updateParams
              )
            }))
          }
        },
        complete: anim => {
          this.placeholderAnim.play()
        }
        // delay: (el, i, l) => {
        //   return i * delay
        // },
        // update: (anim) => {
        //   this.updateAnimationState(anim, 'entered', { entering: {$set: false} })
        // }
      })
      
  }

  componentWillReceiveProps(nextProps) {
    let ids = nextProps.systemMessages.map(msg => msg.id)
    const existingIds = this.props.systemMessages.map(msg => msg.id)
    ids = ids.filter(id => existingIds.indexOf(id) < 0)

    let updateParams = {}
    ids.forEach(id => {
      updateParams[id] = { $set: { entering: false, entered: nextProps.noAnimation } }
    })

    this.setState(prevState => ({
        animations: update(
          prevState.animations,
          updateParams 
        )
      }))
  }

  componentDidUpdate(prevProps, prevState) {
    // animate new messages
    if (prevProps.systemMessages.length < this.props.systemMessages.length
        || (!prevProps.input && this.props.input)) {
      this.animateMessages()
      this.scroll()

      let timestamp = performance.now()
      if (!this.additional_data.message_times) this.additional_data.message_times = []

      let messageIndex = this.props.systemMessages.length - 1

      for (let i = this.additional_data.message_times.length; i < messageIndex - 1; i++) {
        this.additional_data.message_times.push(0)
      }

      this.additional_data.message_times.push(timestamp - this.additional_data.meta.last_message)
      this.additional_data.meta.last_message = timestamp
    }
    // animate out input
    // if (!prevProps.userMessage && this.props.userMessage) {
    //   const timeline = anime.timeline()
    //   timeline
    //     .add({
    //       targets: this.inputTarget,
    //       translateY: 10,
    //       opacity: 0,
    //       duration: 300,
    //       easing: 'easeOutQuad',
    //       complete: anim => {
    //         this.setState({
    //           hideInput: true
    //         })
    //       }
    //     })
    // }
  }

  renderUserMessage() {
    if (this.props.input.type === "slider") {
      return (
        <Intensity 
          defaultValue={+this.props.userMessage.text}
          static={true}
          optionLow={this.props.input.options[0]}
          optionHigh={this.props.input.options[this.props.input.options.length - 1]}
        />
      )
    } else if (this.props.input.type === 'multi-slider') {
      let values = JSON.parse(this.props.userMessage.text)
      let valuesHash = {}
      let stackedOptions = []
      for (let i = 0; i < this.props.input.options.length; i += 2) {
        stackedOptions.push([
          this.props.input.options[i],
          this.props.input.options[i + 1]
        ])
      }
      stackedOptions.forEach((opts, i) => {
        valuesHash[opts[opts.length - 1]] = values[i]
      })
      return (
        <Intensity
          stackedOptions={stackedOptions}
          values={valuesHash}
          static={true}
        />
      )
    } else if (this.props.userMessage.text[0] === '[') {
      return (
        <div className="user-message-list">
          {
            JSON.parse(this.props.userMessage.text)
              .map((text, i) => (
                <Message system={false} 
                    key={this.props.userMessage.id + "-" + i}
                    id={this.props.userMessage.id + "-" + i}
                    animation={{entering: false, entered: true}}> 
                  { text } 
                </Message> 
              ))
          }
        </div>
      )
    } else {
      return (
        <Message system={false} 
            id={this.props.userMessage.id}
            animation={{entering: false, entered: true}}> 
          { this.props.userMessage.text } 
        </Message> 
      )
    }
  }

  renderInput() {
    // const extraClasses = this.state.inputDisabled ? "input-disabled" : ""

    // console.log("INPUT DISABLED", this.state.inputDisabled, new Date().getTime(), this.props.noAnimation)
    // console.log("RENDER INPUT", this.props)
    if (!this.props.input || !this.props.input.active) {
      return (
        <div className="input-placeholder" >
          <div className="tap-hint" style={{opacity: 0.84 * this.state.tapHintFadeAway}}>
            {
              window.screen.height > 800 || window.screen.width > 800 ? this.props.t("browser-tap-to-advance") : this.props.t("mobile-tap-to-advance")
            }
          </div>
        </div>
      )
    }

    switch (this.props.input.type) {
      case "single":
        return (
          <SingleSelect addMessage={this.addMessage} id={this.props.id} 
            inputDisabled={this.state.inputDisabled}
            requireValidation={this.props.input.require_validation}
            longAnswers={this.props.input.long_answers}
            options={this.props.input.options}/>
        )
      case "multi":
        return (
          <MultiSelect addMessage={this.addMessage} id={this.props.id} 
            inputDisabled={this.state.inputDisabled}
            longAnswers={this.props.input.long_answers}
            options={this.props.input.options}/>   
        )
      case "text":
        return (
          <TextEntry addMessage={this.addMessage} id={this.props.id}
            singleline={this.props.input.singleline}/>
        )
      case "slider":
        return (
          <Intensity addMessage={this.addMessage} id={this.props.id}
            optionLow={this.props.input.options[0]}
            optionHigh={this.props.input.options[this.props.input.options.length - 1]}/>
        )
      case "multi-slider":
        let options = this.props.input.options
        let stackedOptions = []
        for (let i = 0; i < options.length; i += 2) {
          stackedOptions.push([options[i], options[i+1]])
        }
        return (
          <Intensity addMessage={this.addMessage} id={this.props.id}
            stackedOptions={stackedOptions} />
        )
      default:
        return '';
    }
  }

  renderMessageContents(message) {
    switch (message.contents.type) {
      case 'text': return message.contents.text
      case 'url': return <img src={message.contents.text} alt="GIF" />
      case 'bar-chart': 
        return <BarChart {...message.contents} />
      default: return message.contents.text
    }
  }

  render() {
    // console.log("RENDERING MSGGRP", this.props, this.state)
    return (
      <div id={this.props.id}>
        {
          this.props.systemMessages.map((msg, i) => (
            <Message key={msg.id} system={true} 
              id={msg.id}
              animation={this.state.animations[msg.id]} 
              avatar={!this.props.noAvatar && (i === 0)}
              noPadding={msg.contents.type === 'url'}
              smallMargin={msg.contents.type === 'bar-chart'}
              >
              { this.renderMessageContents(msg) }
            </Message>
          ))
        }
        { 
          this.props.userMessage && this.props.userMessage.text.length > 0 && 
            this.renderUserMessage()
        }
        { this.props.loading &&
          <Message system={true}
            id={"message-loading"}
            animation={{entering: true, entered: false}}
            avatar={!this.props.systemMessages || this.props.systemMessages.length === 0}/>
        }
        { this.props.errorMessage && 
          <p className="error">
            { this.props.errorMessage }
          </p>
        }
        { 
          !this.props.noAnimation && 
            this.renderInput() 
        }
      </div>
    )
  }
}

export default translate('translations')(MessageGroup);


// WEBPACK FOOTER //
// ./src/components/message-group.js